/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: 失败照片提示条组件
 * @LastEditors: yingongjing
 * @LastEditTime: 2026-02-09 14:35:15
 */

import React from 'react'
import { Button } from 'antd'
import './FailedPhotosNotice.scss'
import { ExclamationCircleOutlined } from '@ant-design/icons'

interface FailedPhotosNoticeProps {
  count: number
  onView: () => void
}

const FailedPhotosNotice: React.FC<FailedPhotosNoticeProps> = ({
  count,
  onView
}) => {
  if (count === 0) {
    return null
  }

  return (
    <div className="failedPhotosNotice">
      <ExclamationCircleOutlined className="failedIcon" />
      <span className="failedText">{count}张照片水印不支持编辑</span>
      <Button type="link" size="small" onClick={onView}>
        查看
      </Button>
    </div>
  )
}

export default FailedPhotosNotice
